import { privGetRequest } from "../vidCloud/priv";

const DownloadDocumentService = {};

DownloadDocumentService.downloadDocument = (docGuid) => {

  return privGetRequest(`/documents/${docGuid}`);
}

DownloadDocumentService.downloadDocumentAttachment = (signerGuid, attachmentGuid) => {
  return privGetRequest(`/signatures/${signerGuid}/attachments/${attachmentGuid}`);
}

export default DownloadDocumentService;